import React from 'react';
import { TableHead, TableRow, TableCell, Box } from '@mui/material';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';

export interface SiteTableHeaderProps {
  sortable?: boolean;
  sortField?: string;
  sortDirection?: 'asc' | 'desc';
  onSort?: (field: string) => void;
}

export const SiteTableHeader: React.FC<SiteTableHeaderProps> = ({
  sortable = false,
  sortField,
  sortDirection,
  onSort,
}) => {
  const handleSort = (field: string) => {
    if (sortable && onSort) {
      onSort(field);
    }
  };

  const renderSortableHeader = (label: string, field: string) => {
    if (sortable) {
      return (
        <TableCell
          sx={{
            color: '#000000',
            fontSize: '12px',
            fontWeight: 500,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            cursor: 'pointer',
            userSelect: 'none',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
          }}
          onClick={() => handleSort(field)}
        >
          <Box display="flex" alignItems="center" gap={0.5}>
            {label}
            {sortField === field && (
              sortDirection === 'asc' ? (
                <KeyboardArrowUpIcon sx={{ fontSize: 14 }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ fontSize: 14 }} />
              )
            )}
          </Box>
        </TableCell>
      );
    } else {
      return (
        <TableCell sx={{ color: '#000000', fontSize: '12px', fontWeight: 500, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
          {label}
        </TableCell>
      );
    }
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell align="center" sx={{ color: '#000000', fontSize: '14px', fontWeight: 500, borderBottom: '1px solid rgba(0, 0, 0, 0.12)', pl: 3, width: 100, minWidth: 100 }}>
        </TableCell>
        {renderSortableHeader('サイト名', 'title')}
        <TableCell sx={{ color: '#000000', fontSize: '12px', fontWeight: 500, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
          URL
        </TableCell>
        {renderSortableHeader('ステータス', 'status')}
        {renderSortableHeader('公開日', 'publishedDate')}
        {renderSortableHeader('クライアント名', 'companyName')}
        {renderSortableHeader('最終更新者', 'updater')}
        {renderSortableHeader('最終更新日時', 'updatedAt')}
        <TableCell align="center" sx={{ color: '#000000', fontSize: '12px', fontWeight: 500, borderBottom: '1px solid rgba(0, 0, 0, 0.12)', position: 'sticky', right: 0, backgroundColor: '#FFFFFF', zIndex: 10, pr: 2 }}>
          アクション
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

